'use client';

import Image from 'next/image';
import { FC, useRef } from 'react';

import VimeoPlayer from '@/components/shared/VimeoPlayer';
import { useVimeoViewportPlayback } from '@/hooks/useVimeoViewportPlayback';

import css from './style.module.scss';

interface Props {
	videoUrl: string;
	thumbnailUrl?: string;
	thumbnailAlt?: string;
	thumbnailLoading?: 'lazy' | 'eager';
	onClick?: () => void;
}

const VideoPreview: FC<Props> = ({
	videoUrl,
	thumbnailUrl,
	thumbnailAlt,
	thumbnailLoading,
	onClick
}) => {
	const containerRef = useRef<HTMLDivElement>(null);
	const playing = useVimeoViewportPlayback(containerRef);

	return (
		<div ref={containerRef} className={css.videoContainer} onClick={onClick}>
			<VimeoPlayer
				fitCover
				muted
				playing={playing}
				className={css.player}
				url={videoUrl}
				thumbnailUrl={thumbnailUrl}
				thumbnailAlt={thumbnailAlt}
				thumbnailLoading={thumbnailLoading}
				preload="metadata"
			/>
			<div className={css.playButton}>
				<Image
					width={12}
					height={12}
					src="/assets/icons/play.svg"
					alt=""
					className={css.playIcon}
				/>
			</div>
		</div>
	);
};

export default VideoPreview;
